module.exports = __webpack_public_path__ + "static/img/btn_smart_sms_app2.761e1a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smart/btn_smart_sms_app2.png
// module id = JvSm
// module chunks = 1